import React, { Component } from 'react';
import ContentSection from './ContentSection';
import { Col, Row } from 'react-materialize';
import { defineMessages, injectIntl } from 'react-intl';

import lionsgateLogo from '../../assets/landing/lionsgate.png';
import nbcLogo from '../../assets/landing/nbc-uni-logo.png';
import newFormLogo from '../../assets/landing/new-form-logo.png';
import ovationLogo from '../../assets/landing/ovation-logo.png';
import snapLogo from '../../assets/landing/snap-logo.png';
import allDefLogo from '../../assets/landing/add-logo.png';

const localeMessages = defineMessages({
	landing_customers_title: {
		id: 'landing_customers.title',
		defaultMessage: `Creators Who Screen With Us`,
	},
});

class LandingCustomers extends Component {

	render() {
		return (
			<ContentSection 
				addedSectionClass='white-bg pb-0' 
				slopeColor='gray' 
				title={this.props.intl.formatMessage(localeMessages.landing_customers_title)}
				sectionEffect='downhill'
			>
				<Row className='valign-wrapper mb-60 landing-custormer-logos-row'>
					<Col s={12} m={6} l={4}>
						<div className='landing-customer-logo-container'>
							<img alt='ovation logo' src={ovationLogo} className='landing-custormer-logos gray-scale' />
						</div>
					</Col>
					<Col s={12} m={6} l={4}>
						<div className='landing-customer-logo-container'>
							<img alt='nbc logo' style={{ height: '2.5rem' }} src={nbcLogo} className='landing-custormer-logos gray-scale' />
						</div>
					</Col>
					<Col s={12} m={6} l={4}>
						<div className='landing-customer-logo-container'>
							<img alt='new form logo' src={newFormLogo} className='landing-custormer-logos gray-scale' />
						</div>
					</Col>
				</Row>

				<Row className='valign-wrapper'>
					<Col s={12} m={6} l={4}>
						<div className='landing-customer-logo-container'>
							<img alt='all def logo' src={allDefLogo} className='landing-custormer-logos gray-scale' />
						</div>
					</Col>
					<Col s={12} m={6} l={4}>
						<div className='landing-customer-logo-container'>
							<img alt='lionsgate logo' style={{ height: '2.5rem'}} src={lionsgateLogo} className='landing-custormer-logos gray-scale' />
						</div>
					</Col>
					<Col s={12} m={6} l={4}>
						<div className='landing-customer-logo-container'>
							<img alt='snap logo' src={snapLogo} className='landing-custormer-logos gray-scale' />
						</div>
					</Col>
				</Row>
			</ContentSection> 
		);
	}
}

export default injectIntl(LandingCustomers);



// WEBPACK FOOTER //
// ./src/components/landing/LandingCustomers.js